export default __webpack_public_path__ + "static/media/friuli.c7eafb21.png";